import { createAction } from 'redux-actions'

export const ACTION_CHANGE_COLLAPSED = 'USER.ACTION_CHANGE_COLLAPSED';

export interface ActionChangeCollapsedPayload {
    collapsed: boolean
}
export const actionChangeCollapsed = createAction(
    ACTION_CHANGE_COLLAPSED,
    (payload: ActionChangeCollapsedPayload) => {
        return payload
    }
);
